@if (loading) {
  <ix-layout-grid>
    <ix-row class="justify-content-start">
      <ix-col class="d-flex justify-content-center" size="8">
        <ix-spinner size="large"></ix-spinner>
      </ix-col>
    </ix-row>
  </ix-layout-grid>
}
@if (!loading && this.categories.length === 0) {
  <ix-layout-grid>
    <ix-row>
      <ix-col class="d-flex justify-content-center" size="12">
        <ix-empty-state
          class="mt-5"
          header="{{ 'battery_pass.viewer.empty_passport_view.header' | translate }}"
          icon="error"
          subHeader="{{ 'battery_pass.viewer.empty_passport_view.sub_header' | translate }}"
        ></ix-empty-state>
      </ix-col>
    </ix-row>
  </ix-layout-grid>
}

@if (this.categories.length > 0) {
  <form [class.invisible]="loading" class="was-validated">
    @for (category of categories; track category) {
      <ix-layout-grid>
        <ix-row>
          <ix-col class="ps-0" size="8">
            <ix-typography
              class="mt-2 mb-3 header-typography"
              format="display-sm"
              id="hl_{{ category.translation.label }}"
            >{{ category.translation.label | translate }}
            </ix-typography>
          </ix-col>
        </ix-row>
        @for (attribute of visibleAttributes(category.attributes); track attribute.valuePath) {
          <ix-row>
            <ix-col class="ps-3 pt-1" size="8">
              @switch (attribute.type) {
                @case ('text') {
                  <app-text-input
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passData]="getData(attribute.valuePath)"
                    [saveFunction]="fieldSaveFunction"
                    [passportId]="passportId"
                  />
                }
                @case ('number') {
                  <app-number-input
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passData]="getData(attribute.valuePath)"
                    [saveFunction]="fieldSaveFunction"
                    [passportId]="passportId"
                  />
                }
                @case ('select') {
                  <app-select-input
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passData]="getData(attribute.valuePath)"
                    [saveFunction]="fieldSaveFunction"
                    [passportId]="passportId"
                  />
                }
                @case ('date') {
                  <app-date-input
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passData]="getData(attribute.valuePath)"
                    [saveFunction]="fieldSaveFunction"
                    [passportId]="passportId"
                  />
                }
                @case ('document') {
                  @if (attribute.attributes?.length) {
                    <app-document-object-input
                      [attribute]="attribute"
                      [passportId]="passportId"
                      [fullValuePath]="attribute.valuePath"
                      [saveFunction]="fieldSaveFunction"
                      [passData]="getData(attribute.valuePath)"
                    />
                  } @else {
                    <app-document-input
                      [attribute]="attribute"
                      [passportId]="passportId"
                      [fullValuePath]="attribute.valuePath"
                      [saveFunction]="fieldSaveFunction"
                      [passData]="getData(attribute.valuePath)"
                    />
                  }
                }
                @case ('url') {
                  <app-document-input
                    [attribute]="attribute"
                    [passportId]="passportId"
                    [fullValuePath]="attribute.valuePath"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                  />
                }
                @case ('list:document') {
                  <app-input-list
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passData]="getData(attribute.valuePath)"
                    [saveFunction]="fieldSaveFunction"
                    [passportId]="passportId"
                    [uiComponents]="uiComponents"
                  />
                }
                @case ('email') {
                  <app-email-input
                    [attribute]="attribute"
                    [passportId]="passportId"
                    [fullValuePath]="attribute.valuePath"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                  />
                }
                @case ('address') {
                  <app-address-input
                    [attribute]="attribute"
                    [passportId]="passportId"
                    [fullValuePath]="attribute.valuePath"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                  />
                }
                @case ('boolean') {
                  <app-boolean-input
                    [attribute]="attribute"
                    [passportId]="passportId"
                    [fullValuePath]="attribute.valuePath"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                  />
                }
                @case ('language') {
                  <app-language-text-input
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passportId]="passportId"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                  />
                }
                @case ('list:text') {
                  <app-input-list-text
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passportId]="passportId"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                  />
                }
                @case ('list') {
                  <app-input-list
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passData]="getData(attribute.valuePath)"
                    [saveFunction]="fieldSaveFunction"
                    [passportId]="passportId"
                    [uiComponents]="uiComponents"
                  />
                }
                @case ('list:language') {
                  <app-input-list
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passData]="getData(attribute.valuePath)"
                    [saveFunction]="fieldSaveFunction"
                    [passportId]="passportId"
                    [uiComponents]="uiComponents"
                  />
                }
                @case ('chart:pie') {
                  <app-input-list
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passportId]="passportId"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                    [uiComponents]="uiComponents"
                  />
                }
                @case ('chart:bar') {
                  <app-input-list
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passportId]="passportId"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                    [uiComponents]="uiComponents"
                  />
                }
                @case ('chart:line') {
                  <app-input-list
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passportId]="passportId"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                    [uiComponents]="uiComponents"
                  />
                }
                @case ('detail') {
                  <app-input-list
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passportId]="passportId"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                    [uiComponents]="uiComponents"
                  />
                }
                @case ('name-id') {
                  <app-name-id-input
                    [attribute]="attribute"
                    [fullValuePath]="attribute.valuePath"
                    [passportId]="passportId"
                    [saveFunction]="fieldSaveFunction"
                    [passData]="getData(attribute.valuePath)"
                  />
                }
                @case ('imagePicker') {
                  <app-image-input
                    [attribute]="attribute"
                    [images]="attribute.data?.images ?? []"
                    [fullValuePath]="attribute.valuePath"
                    [saveFunction]="fieldSaveFunction"
                    [passportId]="passportId"
                    [passData]="getData(attribute.valuePath)"
                  />
                }
                @default {
                  <ix-message-bar [persistent]="true" type="warning">
                    {{ 'battery_pass.edit.component_not_found' | translate: {type: attribute.type} }}
                  </ix-message-bar>
                }
              }
            </ix-col>
            <ix-col
              [ngClass]="{
                'assignment-alignment': !listTypes.includes(attribute.type || ''),
                'assignment-alignment-list': listTypes.includes(attribute.type || '')
              }"
              class="align-self-start"
              size="4"
            >
              @if (getAttributeLabel(attribute); as label) {
                @if (isAttributeAssignedTo(attribute)) {
                  <ix-chip
                    (click)="onAttributeAssignmentClicked(label, attribute)"
                    id="attributeAssignment.{{ attribute.name }}"
                    onkeypress=""
                    [outline]="true"
                  >
                    <ix-typography class="d-flex align-items-center">
                      <ix-icon class="me-3 assigned-icon" name="plus"></ix-icon>
                      {{ 'battery_pass.edit.assigned_to'| translate: {user: label?.assigneeEmail} }}
                    </ix-typography>
                  </ix-chip>
                }
                @if (isAttributeSubmittedBy(attribute)) {
                  <ix-chip
                    (click)="onAttributeAssignmentClicked(label, attribute)"
                    class="custom-coloring"
                    id="attributeAssignment.{{ attribute.name }}"
                    onkeypress=""
                    [outline]="true"
                    variant="custom"
                  >
                    <ix-typography class="d-flex align-items-center">
                      <ix-icon class="me-3 submitted-icon"
                               name="arrow-down-right"></ix-icon>
                      {{
                        'battery_pass.edit.submitted_by'
                          | translate: {user: label?.assigneeEmail}
                      }}
                    </ix-typography>
                  </ix-chip>
                }
              }
            </ix-col>
          </ix-row>
        }
      </ix-layout-grid>
    }
    <ix-layout-grid class="sticky z-2 bottom-0 bottom-background">
      <ix-row>
        <ix-col
          class="d-flex flex-row justify-content-end gap-1 bottom-background align-items-center"
          size="8">
          @if (passportIsSaving) {
            <ix-typography>Saving...</ix-typography>
            <ix-spinner class="me-3" size="small"></ix-spinner>
          }
          <ix-button
            class="dismiss-modal"
            id="batteryPassWorkflowCancelButton"
            onkeypress=""
            (click)="onCancelClick()"
            variant="secondary"
          >{{ 'general.cancel' | translate }}
          </ix-button>
          @if (purpose !== 'assignment') {
            <ix-split-button
              (buttonClick)="onSubmitClick(this.passportStatus)"
              class="close-modal"
              id="batteryPassWorkflowSubmitButton"
              label="{{`battery_pass.edit.edit_button_text_${passportStatus}` | translate}}"
              splitIcon="chevron-down-small"
              variant="primary"
            >
              <ix-dropdown-item
                (click)="onSubmitClick(StatusStringEnum.DRAFT)"
                id="batteryPassWorkflowSubmitButtonSplitDraft"
                label="{{ `battery_pass.edit.edit_button_text_draft` | translate }}"
                onkeypress=""
                [icon]="passportStatus === 'draft' ? 'checkbox' : 'checkbox-empty'"
              ></ix-dropdown-item>
              <ix-dropdown-item
                (click)="onSubmitClick(StatusStringEnum.COMPLETED)"
                id="batteryPassWorkflowSubmitButtonSplitDone"
                label="{{ `battery_pass.edit.edit_button_text_complete` | translate }}"
                onkeypress=""
                [icon]="passportStatus === 'draft' ? 'checkbox-empty' : 'checkbox'"
              ></ix-dropdown-item>
            </ix-split-button>
          }
          @if (purpose === 'assignment') {
            <ix-button
              (click)="onSubmitClick(this.passportStatus)"
              id="dataProviderAssignmentSaveButtonCX"
              onkeypress=""
              variant="primary"
            >{{
                (
                  isCatenaX ? 'battery_pass.attribute_selection.save_cx' :
                    'battery_pass.attribute_selection.save_api') | translate
              }}
            </ix-button>
          }
        </ix-col>
      </ix-row>
    </ix-layout-grid>
  </form>
}
